<template>
  <div v-if="theme == false" class="row">
    <div class="col-sm-12 col-12" v-show="resistanceTrendline">
      <div class="text-center" v-if="theme == false">
        <q-btn
          class="q-px-md text-bold"
          v-if="this.$store.state.authenticate.isAuthenticated"
          color="primary"
          label="Signals "
          style="font-size: 8px; margin: 1px 3px 0px 3px"
          @click="tvToggles.buySell = !tvToggles.buySell"
          :outline="!tvToggles.buySell"
        >
          <q-tooltip class="bg-primary">signal</q-tooltip>
        </q-btn>
        <q-btn
          class="q-mx-xs q-px-md text-bold"
          color="green"
          label="Support"
          style="font-size: 8px; margin: 1px 3px 0px 3px"
          @click="tvToggles.support = !tvToggles.support"
          :outline="!tvToggles.support"
        >
          <q-tooltip class="bg-green">support</q-tooltip>
        </q-btn>
        <q-btn
          class="q-mx-xs q-px-md text-bold"
          color="red"
          label="Resistance"
          style="font-size: 8px; margin: 1px 3px 0px 3px"
          @click="tvToggles.resistance = !tvToggles.resistance"
          :outline="!tvToggles.resistance"
        >
          <q-tooltip class="bg-red">resistance</q-tooltip>
        </q-btn>
        <q-btn
          class="q-mx-xs q-px-md text-bold"
          :class="this.$q.dark.mode ? 'text-grey-6' : 'text-white'"
          :color="this.$q.dark.mode ? 'grey-2' : 'black'"
          label="Trendline"
          style="font-size: 8px; margin: 1px 3px 0px 3px"
          @click="tvToggles.trendline = !tvToggles.trendline"
          :outline="!tvToggles.trendline"
        >
          <q-tooltip class="bg-grey-6">trendline</q-tooltip>
        </q-btn>
        <q-btn
          class="q-mx-xs q-px-md text-bold"
          v-if="
            routeName != 'FourChartsLayout' &&
            routeName != 'TwoChartsLayout' &&
            routeName != 'ThreeChartsLayout' &&
            routeName != 'FiveChartsLayout' &&
            routeName != 'SixChartsLayout'
          "
          color="orange"
          label="Adjusted"
          style="font-size: 8px; margin: 1px 3px 0px 3px"
          @click="tvToggles.adjusted = !tvToggles.adjusted"
          :outline="!tvToggles.adjusted"
        >
          <q-tooltip class="bg-orange">adjusted</q-tooltip>
        </q-btn>
        <q-btn
          class="q-mx-xs q-px-md text-bold"
          color="secondary"
          label="High - Low"
          style="font-size: 8px; margin: 1px 3px 0px 3px"
          @click="tvToggles.highLow = !tvToggles.highLow"
          :outline="!tvToggles.highLow"
        >
          <q-tooltip class="bg-secondary">high low</q-tooltip>
        </q-btn>
        <q-btn
          v-if="isSignalType"
          class="q-mx-xs q-px-md text-bold"
          color="cyan"
          label="SL & PT"
          style="font-size: 8px; margin: 1px 3px 0px 3px"
          @click="tvToggles.sl_pt = !tvToggles.sl_pt"
          :outline="!tvToggles.sl_pt"
        >
          <q-tooltip class="bg-cyan">stop loss & profit target</q-tooltip>
        </q-btn>
      </div>
    </div>
    <div class="col-sm-2 col-2">
      <span
        class="text-subtitle1 text-weight-bold"
        :class="this.$q.dark.mode ? 'text-grey-3' : 'text-primary'"
        v-show="routeName != 'NepalStockExchangeTechnicalCharts'"
        v-if="chukulIcon"
      >
        <q-icon name="meeting_room" class="q-pa-xs q-mb-sm" />
      </span>
    </div>
  </div>

  <div :class="this.$q.dark.mode ? 'dark-bg bg-dark' : 'bg-white'">
    <div
      class="TVChartContainer"
      ref="chartContainer"
      :style="setTradingViewHeight"
    ></div>
  </div>
</template>

<script>
import { useQuasar, LocalStorage } from "quasar";
import { useRouter, useRoute } from "vue-router";
// import ChukulCustomIndicator from "./CustomIndicators/ChukulCustomIndicator.js";
import useSupport from "./Drawings/supportLine.js";

import {
  ref,
  onMounted,
  onUnmounted,
  watch,
  watchEffect,
  computed,
  onBeforeUnmount,
} from "vue";
import { widget } from "../../../public/charting_library_24";
import Datafeed from "../../plugins/tv-datafeed/index.js";
import { useStore } from "vuex";
import useData from "src/use/data";
import useLoadIndicators from "./LoadIndicators/loadindicators.js";
import mapTimePeriod from "./shared.js";

export default {
  name: "NepalStockExchangeTechnicalChart",
  emits: ["selectedSymbol"],
  props: {
    footerHeight: {
      type: String,
    },
    heightWhenFooterisOn: {
      type: String,
      default: () => "40vh",
    },
    indicators: {
      type: Array,
      default: () => [],
    },
    timePeriod: {
      type: String,
      default: "daily",
    },
    theme: {
      type: Boolean,
      default: false,
    },
    footerFullHeight: {
      type: Boolean,
    },
    footerScreen: {
      type: Boolean,
    },
    fullHeight: {
      type: Boolean,
    },
    chukulIcon: {
      default: false,
    },
    resistanceTrendline: {
      default: true,
    },
    multipleChartLayout: {
      default: false,
    },
    preset: {
      default: null,
    },
    symbol: {
      type: String,
      default: "NEPSE",
    },
    height: {},
    toggles: {
      default: {
        buySell: true,
        highLow: true,
        // buySellEarly: true,
        support: true,
        resistance: true,
        trendline: true,
        sl_pt: true,
        adjusted: true,
      },
    },
    backTestdata: {
      type: Array,
      default() {
        return ["No Data."];
      },
    },
    candleStickData: {
      type: Array,
      default() {
        return ["No Data."];
      },
    },
    buySellTargetData: {
      type: Array,
      default() {
        return ["No Data."];
      },
    },
    signalTypedata: {
      type: Array,
      default() {
        return ["No Data."];
      },
    },
    isSignalType: {
      type: Boolean,
      default: false,
    },
    isPMDDSignalType: {
      type: Boolean,
      default: false,
    },
    isMySignalSignal: {
      type: Boolean,
      default: false,
    },
    signaltype: {
      type: String,
      default: "",
    },
    alertOrSignal: {
      type: String,
      default: "",
    },
    isThisStock: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const isCapacitor = ref(process.env.IS_CAPACITOR);
    const $q = useQuasar();
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const { loadIndicators } = useLoadIndicators();
    const { drawSupportLine } = useSupport();

    const tvWidget = ref(null);

    let tvSymbol = ref(
      $route.query.symbol ? $route.query.symbol : props.symbol
    );

    const tvPreset = ref(props.preset);
    const tvHeight = ref(props.height);
    const entityId = ref(null);
    const chartContainer = ref(null);
    const s1 = ref(null);
    const s2 = ref(null);
    const s3 = ref(null);
    const r1 = ref(null);
    const r2 = ref(null);
    const r3 = ref(null);
    const trendLine1 = ref(null);
    const trendLine2 = ref(null);
    const trendLine3 = ref(null);
    const trendLine4 = ref(null);
    let sl_pt_Id1 = ref(null);
    let sl_pt_Id2 = ref(null);
    let sl_pt_Id3 = ref(null);
    let sl_pt_Id4 = ref(null);
    let sl_pt_Id5 = ref(null);
    let sl_pt_Id6 = ref(null);
    let sl_pt_Id7 = ref(null);
    let sl_pt_Id8 = ref(null);
    let sl_pt_Id9 = ref(null);
    const buySell = ref([]);
    const highLow = ref([]);
    const candleStick = ref([]);
    const buyTarget = ref(null);
    const sellTarget = ref(null);

    let tvResolution = ref("D");

    const routeName = computed(() => {
      return useRoute()?.name;
    });

    const setTradingViewHeight = computed(() => {
      const isNepalStockCharts =
        routeName.value === "NepalStockExchangeTechnicalCharts";

      const isSingleChart = [
        "NepalStockExchangeTechnicalChart",
        "TradingviewThemeChart",
      ].includes(routeName.value);

      const isMultiChart = [
        "TwoChartsLayout",
        "ThreeChartsLayout",
        "FourChartsLayout",
        "FiveChartsLayout",
        "SixChartsLayout",
        "MultipleLayout",
      ].includes(routeName.value);

      if (isNepalStockCharts) {
        if (props.footerFullHeight) return { display: "none" };
        if (props.footerScreen) return { height: props.heightWhenFooterisOn };
        return {
          height: props.isThisStock
            ? `calc(97vh - ${props.footerHeight}px)`
            : "97vh",
        };
      }

      if (isSingleChart) return { height: "100vh" };
      if (isMultiChart) return { height: "48vh" };

      return { height: "460px" };
    });

    const {
      buySellSearch,
      highlowDataSearchSymbolWise,
      highlowHourlyDataSearchSymbolWise,
      highlowWeeklyDataSearchSymbolWise,
      resistanceDataSearch,
      resistanceDataSearchHourly,
      resistanceDataSearchWeekly,
      supportDataSearch,
      supportDataSearchHourly,
      supportDataSearchWeekly,
    } = useData();

    const isDarkTheme = ref(false);
    const priceHistory = ref([]);
    const tvToggles = ref(props.toggles);

    const toggleTheme = () => {
      tvWidget.value?.onChartReady(() => {
        isDarkTheme.value = !isDarkTheme.value;
        isDarkTheme.value ? $q.dark.set(true) : $q.dark.set(false);
        const newTheme = isDarkTheme.value ? "Dark" : "Light";
        tvWidget.value.changeTheme(newTheme);
        if (newTheme == "Dark") {
          LocalStorage.set("darkTheme", true);
        } else if (newTheme == "Light") {
          LocalStorage.set("darkTheme", false);
        }
      });
    };

    if (props.isPMDDSignalType) {
      tvToggles.value.buySell = false;
      tvToggles.value.support = false;
      tvToggles.value.resistance = false;
      tvToggles.value.trendline = false;
      tvToggles.value.sl_pt = true;
    } else if (() => props.isSignalType) {
      if (routeName.value === "Dashboard") {
        tvToggles.value.buySell = false;
        tvToggles.value.support = true;
        tvToggles.value.resistance = true;
        tvToggles.value.trendline = true;
        tvToggles.value.sl_pt = true;
      } else if (
        routeName.value === "PriceActionSignals" ||
        routeName.value === "MeanReversalSignal" ||
        routeName.value === "Divergence" ||
        routeName.value === "DowSignals"
      ) {
        tvToggles.value.buySell = false;
        tvToggles.value.support = false;
        tvToggles.value.resistance = false;
        tvToggles.value.trendline = false;
        tvToggles.value.sl_pt = true;
      } else if (
        routeName.value === "NepalStockExchangeTechnicalCharts" ||
        routeName.value === "NepalStockExchangeTechnicalChart" ||
        routeName.value === "TwoChartsLayout" ||
        routeName.value === "ThreeChartsLayout" ||
        routeName.value === "FourChartsLayout" ||
        routeName.value === "FiveChartsLayout" ||
        routeName.value === "SixChartsLayout" ||
        routeName.value === "MultipleLayout"
      ) {
        tvToggles.value.buySell = false;
        tvToggles.value.support = false;
        tvToggles.value.resistance = false;
        tvToggles.value.trendline = false;
        tvToggles.value.highLow = false;
        tvToggles.value.sl_pt = true;
      } else if (
        routeName.value === "WeeklySignal" ||
        routeName.value === "DailySignal" ||
        routeName.value === "BackTestEngine"
      ) {
        tvToggles.value.buySell = true;
        tvToggles.value.support = false;
        tvToggles.value.resistance = false;
        tvToggles.value.trendline = false;
        tvToggles.value.sl_pt = true;
      } else if (routeName.value === "StockProfile") {
        tvToggles.value.buySell = true;
        tvToggles.value.support = true;
        tvToggles.value.resistance = true;
        tvToggles.value.trendline = true;
        tvToggles.value.sl_pt = false;
      } else {
        tvToggles.value.buySell = true;
        tvToggles.value.support = true;
        tvToggles.value.resistance = true;
        tvToggles.value.trendline = true;
        tvToggles.value.sl_pt = true;
      }
    }

    watchEffect(() => {
      LocalStorage.set("tvAdjusted", tvToggles.value.adjusted);
    });

    onMounted(() => {
      LocalStorage.set("tvAdjusted", tvToggles.value.adjusted);
      isDarkTheme.value = LocalStorage.getItem("darkTheme");
      isDarkTheme.value ? $q.dark.set(true) : $q.dark.set(false);
      if ($store.state.authenticate.isAuthenticated) {
        $store.dispatch("accounts/whoAmI").then((res) => {
          if ($store.state.accounts.whoAmI.id) {
            loadTradingViewChart($store.state.accounts.whoAmI.id);
            return;
          }
        });
      } else {
        loadTradingViewChart(null);
      }
    });

    watch(
      [() => props.symbol, () => tvSymbol.value],
      (newPropsSymbol, oldPropsSymbol) => {
        newPropsSymbol.forEach((symbol) => {
          if (symbol !== oldPropsSymbol[0]) {
            tvSymbol.value = symbol;
          }
        });
      }
    );

    watch(
      () => tvSymbol,

      (newTvSymbol, oldTvSymbol) => {
        tvWidget.value?.onChartReady(() =>
          tvWidget.value.activeChart().setSymbol(tvSymbol.value, () => {
            if (tvResolution.value == "1D" || tvResolution.value == "D")
              loadShapes(true, "D");
            if (tvResolution.value == "1W" || tvResolution.value == "W")
              loadShapes(true, "W");
            if (tvResolution.value == "60") loadShapes(true, "60");
          })
        );

        context.emit("selectedSymbol", newTvSymbol.value);
      },
      { deep: true }
    );

    watch(
      () => props.candleStickData,
      (newPropscandleStickData, oldPropscandleStickData) => {
        let id;
        tvWidget.value?.onChartReady(() => {
          tvWidget.value
            .activeChart()
            .onVisibleRangeChanged()
            .subscribe(null, ({ from, to }) => {
              clearTimeout(id);
              id = setTimeout(() => {
                clearShapes(true, "candleStick").then(() => {
                  drawCandleStickComment(props.candleStickData);
                });
              }, 500);
            });
        });

        clearShapes(true, "candleStick").then(() => {
          drawCandleStickComment(props.candleStickData);
        });
      },
      { deep: true }
    );

    watch(
      () => props.buySellTargetData,
      (newbuySellTargetData, oldbuySellTargetData) => {
        let id;
        tvWidget.value?.onChartReady(() => {
          tvWidget.value
            .activeChart()
            .onVisibleRangeChanged()
            .subscribe(null, ({ from, to }) => {
              clearTimeout(id);
              id = setTimeout(() => {
                clearShapes(true, "buySellTarget").then(() => {
                  drawBuySellTarget(props.buySellTargetData);
                });
              }, 500);
            });
        });

        clearShapes(true, "buySellTarget").then(() => {
          drawBuySellTarget(props.buySellTargetData);
        });
      },
      { deep: true }
    );

    watch(
      () => props.signalTypedata,
      (newSignalTypedata, oldSignalTypedata) => {
        let id;
        tvWidget.value?.onChartReady(() => {
          tvWidget.value
            .activeChart()
            .onVisibleRangeChanged()
            .subscribe(null, ({ from, to }) => {
              clearTimeout(id);
              id = setTimeout(() => {
                if (props.toggles.sl_pt) {
                  clearShapes(true, "sl_pt").then(() => {
                    drawSignalsLine(props.newSignalTypedata);
                  });
                }
              }, 500);
            });
        });
        if (props.toggles.sl_pt) {
          clearShapes(true, "sl_pt").then(() => {
            drawSignalsLine(props.newSignalTypedata);
          });
        }
      },
      { deep: true }
    );

    watch(
      () => $store.state.authenticate.isAuthenticated,
      (newVal, oldVal) => {
        if (newVal == false) loadTradingViewChart(null);
      }
    );

    watch(
      [
        () => tvToggles.value.support,
        () => tvToggles.value.resistance,
        () => tvToggles.value.trendline,
        () => tvToggles.value.buySell,
        () => tvToggles.value.highLow,
        () => tvToggles.value.adjusted,
        () => tvToggles.value.sl_pt,
      ],
      (newVal, oldVal) => {
        const changedIndex = newVal.findIndex(
          (value, index) => value !== oldVal[index]
        );
        const changedVariable = [
          "support",
          "resistance",
          "trendline",
          "buysell",
          "highlow",
          "adjusted",
          "sl_pt",
        ][changedIndex];

        clearShapesGetApiDataAndThenDrawShpaes(
          tvResolution.value,
          changedVariable
        );
      }
    );
    function loadTradingViewChart(userId = null) {
      const widgetOptions = {
        symbol: tvSymbol.value,
        datafeed: Datafeed,
        interval: "D",
        container: chartContainer.value,
        library_path: "/charting_library_24/",
        timezone: "Asia/Kathmandu",
        height: tvHeight.value || "100%",
        fullscreen: tvPreset.value == "mobile" ? false : false,
        width: "100%",
        // custom_indicators_getter: function (PineJS) {
        //   return Promise.resolve([ChukulCustomIndicator(PineJS)]);
        // },
        disabled_features: props.multipleChartLayout
          ? ["timeframes_toolbar"]
          : tvPreset.value == "mobile"
          ? [
              "left_toolbar",
              // "header_widget",
              "edit_buttons_in_legend",
              "border_around_the_chart",
              "timeframes_toolbar",
            ]
          : [],
        theme: $q.dark.mode ? "Dark" : "Light",
        loading_screen: $q.dark.mode ? "#333" : "#fff",
        locale: "en",
        // enabled_features: ["study_templates"],
        charts_storage_url: $store.state.authenticate.isAuthenticated
          ? `${process.env.BASE_URL}/api`
          : "",
        charts_storage_api_version: "charts",
        user_id: userId,
        client_id: "chukul.com",
        scale: 2,
        // autosize: true,
        studies_overrides: null,
      };

      tvWidget.value = new widget(widgetOptions);

      tvWidget.value.headerReady().then(function () {
        mapTimePeriod[props.timePeriod]
          ? tvWidget.value
              .activeChart()
              .setResolution(mapTimePeriod[props.timePeriod])
          : tvWidget.value.activeChart().setResolution("D");
      });

      tvWidget.value?.onChartReady(function () {
        tvWidget.value.headerReady().then(function () {
          var button = tvWidget.value.createButton();
          changeButtonStyle();
          watch(
            () => $q.dark.mode,
            (newVal, oldVal) => {
              changeButtonStyle();
              updateLogo();
            }
          );

          function changeButtonStyle() {
            if ($q.dark.mode) {
              button.setAttribute("style", "color:#ffffff;cursor:pointer");
              button.setAttribute("title", "Light");
              button.textContent = "Light";
            } else {
              button.setAttribute("style", "color:#000000; cursor:pointer");
              button.setAttribute("title", "Dark");
              button.textContent = "Dark";
            }
          }

          button.addEventListener("click", function () {
            toggleTheme();
            changeButtonStyle();
          });
          var chukulButton = tvWidget.value.createButton();

          var multiChart = tvWidget.value.createButton();
          multiChart.setAttribute("title", "Multi Chart");
          multiChart.setAttribute("style", "cursor:pointer");
          multiChart.innerHTML = `
                <span style="font-size: 32px; display: inline-flex; 
                justify-content: center; margin-bottom: 8px;"> □ </span>
                  `;

          multiChart.addEventListener("click", function () {
            if ($route.name !== "MultipleLayout") {
              const routeUrl = $router.resolve({
                name: "MultipleLayout",
                params: { layout: 2 },
              }).href;
              window.open(routeUrl, "_blank");
            }
          });

          var img = document.createElement("img");
          img.style.width = "100px";
          img.style.height = "22px";
          img.style.marginTop = "8px";

          function updateLogo() {
            img.src = $q.dark.mode
              ? "/images/LogoDark.png"
              : "/images/Logo.png";
          }

          updateLogo();
          chukulButton.appendChild(img);
          chukulButton.setAttribute(
            "style",
            "cursor:pointer; height:100%; box-sizing:border-box; padding:0px"
          );
          chukulButton.addEventListener("click", function () {
            $router.push({ name: "Dashboard" });
          });
        });
      });

      tvWidget.value?.onChartReady(() => {
        tvResolution.value = tvWidget.value.activeChart().resolution();
        watch(tvResolution, (newVal, oldVal) => {
          setTimeout(() => {
            clearShapesGetApiDataAndThenDrawShpaes(newVal, "support");
            clearShapesGetApiDataAndThenDrawShpaes(newVal, "resistance");
            clearShapesGetApiDataAndThenDrawShpaes(newVal, "trendline");
            clearShapesGetApiDataAndThenDrawShpaes(newVal, "buysell");
            clearShapesGetApiDataAndThenDrawShpaes(newVal, "highlow");
            clearShapesGetApiDataAndThenDrawShpaes(newVal, "sl_pt");
          }, 1000);
        });
        watch(
          () => props.backTestdata,
          (newVal, oldVal) => {
            setTimeout(() => {
              clearShapesGetApiDataAndThenDrawShpaes(
                tvResolution.value,
                "support"
              );
              clearShapesGetApiDataAndThenDrawShpaes(
                tvResolution.value,
                "resistance"
              );
              clearShapesGetApiDataAndThenDrawShpaes(
                tvResolution.value,
                "trendline"
              );
              clearShapesGetApiDataAndThenDrawShpaes(
                tvResolution.value,
                "buysell"
              );
              clearShapesGetApiDataAndThenDrawShpaes(
                tvResolution.value,
                "highlow"
              );
              clearShapesGetApiDataAndThenDrawShpaes(
                tvResolution.value,
                "sl_pt"
              );
            }, 1000);
          }
        );

        tvWidget.value
          .activeChart()
          .onIntervalChanged()
          .subscribe(null, (interval, timeframeObj) => {
            tvResolution.value = interval;
            loadShapes(true);
            clearShapes(true, "buysell");
            clearShapes(true, "highlow");
          });

        const newTheme = isDarkTheme.value ? "Dark" : "Light";
        tvWidget.value.changeTheme(newTheme);
        tvWidget.value
          .activeChart()
          .onSymbolChanged()
          .subscribe(null, (e) =>
            tvWidget.value?.onChartReady(() => {
              tvSymbol.value = e.ticker;
              context.emit("selectedSymbol", e.ticker);
            })
          );
      });
      if (props.indicators.length || $route.query.indicator) {
        tvWidget.value.onChartReady(() => {
          loadIndicators(tvWidget.value, props.indicators, $route);
        });
      }
      tvWidget.value.onChartReady(() => {
        tvWidget.value.headerReady().then(function () {
          if (routeName.value == "Dashboard") {
            tvWidget.value.activeChart().removeAllStudies();
            tvWidget.value.activeChart().createStudy("Volume", true, true);
          }
        });
        $store.state.chartsymbol.activeIndicators?.forEach((i) => {
          if (i.name != "Volume")
            tvWidget.value.activeChart().createStudy(i.name, false, false);
        });
      });

      watch(
        () => props.indicators,
        (newVal, oldVal) => {
          loadIndicators(tvWidget.value, props.indicators);
        }
      );

      loadShapes(true, tvResolution.value);

      watch(
        () => $q.dark.mode,
        (newVal, oldVal) => {
          loadShapes(true, tvResolution.value);
          if (1) {
            tvWidget.value?.onChartReady(() => {
              let newTheme = newVal ? "Dark" : "Light";
              tvWidget.value.changeTheme(newTheme);
            });
          }
        }
      );
    }

    const removeEntity = (entity) => {
      if (entity) {
        tvWidget.value.activeChart().removeEntity(entity, {
          disableUndo: true,
        });
      }
      return null;
    };

    function clearShapes(newSymbol = false, changedVariable) {
      return new Promise(async (resolve, reject) => {
        try {
          tvWidget.value?.onChartReady(() => {
            if (changedVariable == "support" && (newSymbol || true)) {
              s1.value = removeEntity(s1.value);
              s2.value = removeEntity(s2.value);
              s3.value = removeEntity(s3.value);
            }

            if (changedVariable == "resistance" && (newSymbol || true)) {
              r1.value = removeEntity(r1.value);
              r2.value = removeEntity(r2.value);
              r3.value = removeEntity(r3.value);
            }

            if (changedVariable == "trendline" && (newSymbol || true)) {
              trendLine1.value = removeEntity(trendLine1.value);
              trendLine2.value = removeEntity(trendLine2.value);
              trendLine3.value = removeEntity(trendLine3.value);
              trendLine4.value = removeEntity(trendLine4.value);
            }

            if (changedVariable == "sl_pt" && (newSymbol || true)) {
              sl_pt_Id1.value = removeEntity(sl_pt_Id1.value);
              sl_pt_Id2.value = removeEntity(sl_pt_Id2.value);
              sl_pt_Id3.value = removeEntity(sl_pt_Id3.value);
              sl_pt_Id4.value = removeEntity(sl_pt_Id4.value);
              sl_pt_Id5.value = removeEntity(sl_pt_Id5.value);
              sl_pt_Id6.value = removeEntity(sl_pt_Id6.value);
              sl_pt_Id7.value = removeEntity(sl_pt_Id7.value);
              sl_pt_Id8.value = removeEntity(sl_pt_Id8.value);
              sl_pt_Id9.value = removeEntity(sl_pt_Id9.value);
            }

            if (changedVariable == "buysell") {
              if (newSymbol || true) {
                if (buySell.value.length) {
                  buySell.value.forEach(async (d) => {
                    if (d) {
                      tvWidget.value.activeChart().removeEntity(d, {
                        disableUndo: true,
                      });
                    }
                  });
                }
                buySell.value = [];
              }
            }

            if (changedVariable == "highlow") {
              if (newSymbol || true) {
                if (highLow.value.length) {
                  highLow.value.forEach(async (d) => {
                    if (d) {
                      tvWidget.value.activeChart().removeEntity(d, {
                        disableUndo: true,
                      });
                    }
                  });
                }
                highLow.value = [];
              }
            }

            if (changedVariable == "candleStick") {
              if (newSymbol || true) {
                if (candleStick.value.length) {
                  candleStick.value.forEach(async (d) => {
                    if (d) {
                      tvWidget.value.activeChart().removeEntity(d, {
                        disableUndo: true,
                      });
                    }
                  });
                }
                candleStick.value = [];
              }
            }

            if (changedVariable == "buySellTarget") {
              if (newSymbol || true) {
                buyTarget.value = removeEntity(buyTarget.value);
                sellTarget.value = removeEntity(sellTarget.value);
              }
            }
          });

          resolve();
        } catch (error) {
          reject(error);
        }
      });
    }

    function createMultipointShapeLine(price, color, text, linewidth) {
      return tvWidget.value.activeChart().createMultipointShape([{ price }], {
        shape: "horizontal_line",
        lock: true,
        disableSelection: true,
        disableSave: true,
        disableUndo: true,
        text: text,
        overrides: {
          showLabel: true,
          vertLabelsAlign: "bottom",
          horzLabelsAlign: "right",
          linecolor: color,
          showPrice: true,
          textcolor: color,
          fontsize: 14,
          linewidth: linewidth,
        },
      });
    }

    function createArrowShape(time, channel, color, arrowText) {
      return tvWidget.value.activeChart().createShape(
        { time, channel },
        {
          shape: channel === "low" ? "arrow_up" : "arrow_down",
          text: arrowText,
          zOrder: "top",
          overrides: {
            color,
            arrowColor: color,
            fontsize: 10,
            font: "Arial",
          },
          lock: true,
          disableSelection: true,
          disableSave: true,
          disableUndo: true,
        }
      );
    }

    function drawSignalsLine() {
      if ($store.state.authenticate.isAuthenticated && props.isSignalType) {
        tvWidget.value?.onChartReady(() => {
          const { signalTypedata, signaltype, alertOrSignal } = props;

          if (signalTypedata.trailing_stop_loss) {
            sl_pt_Id9.value =
              sl_pt_Id9.value ||
              createMultipointShapeLine(
                signalTypedata.trailing_stop_loss,
                "red",
                `Trailing Stop Loss @ ${signalTypedata.trailing_stop_loss.toFixed(
                  2
                )}`,
                1
              );
          }
          if (signalTypedata.stop_loss) {
            sl_pt_Id1.value =
              sl_pt_Id1.value ||
              createMultipointShapeLine(
                signalTypedata.stop_loss,
                "red",
                `Stop Loss @ ${signalTypedata.stop_loss.toFixed(2)}`,
                2
              );
          }
          if (signalTypedata.profit_target) {
            sl_pt_Id2.value =
              sl_pt_Id2.value ||
              createMultipointShapeLine(
                signalTypedata.profit_target,
                "green",
                `Profit Target @ ${signalTypedata.profit_target.toFixed(2)}`,
                2
              );
          }
          if (signalTypedata.profit_target1) {
            sl_pt_Id3.value =
              sl_pt_Id3.value ||
              createMultipointShapeLine(
                signalTypedata.profit_target1,
                "green",
                `Profit Target1 @ ${signalTypedata.profit_target1.toFixed(2)}`,
                2
              );
          }
          if (signalTypedata.profit_target2) {
            sl_pt_Id4.value =
              sl_pt_Id4.value ||
              createMultipointShapeLine(
                signalTypedata.profit_target2,
                "green",
                `Profit Target2 @ ${signalTypedata.profit_target2.toFixed(2)}`,
                2
              );
          }
          if (signalTypedata?.entry_point) {
            sl_pt_Id5.value =
              sl_pt_Id5.value ||
              createMultipointShapeLine(
                signalTypedata?.entry_point,
                "blue",
                `${
                  signaltype === "buy" ? "Entry Above" : "Exit Below"
                } @ ${signalTypedata?.entry_point?.toFixed(2)}`,
                2
              );
          }
          if (signalTypedata?.buy_price) {
            sl_pt_Id6.value =
              sl_pt_Id6.value ||
              createMultipointShapeLine(
                signalTypedata?.buy_price,
                "blue",
                `Entry Point From ${(signalTypedata?.buy_price * 0.99)?.toFixed(
                  2
                )} To ${signalTypedata?.buy_price?.toFixed(2)}`,
                1
              );

            sl_pt_Id7.value =
              sl_pt_Id7.value ||
              createMultipointShapeLine(
                signalTypedata?.buy_price * 0.99,
                "blue",
                ``,
                1
              );
          }
          if (signalTypedata.date) {
            sl_pt_Id8.value =
              sl_pt_Id8.value ||
              createArrowShape(
                new Date(signalTypedata.date).getTime() / 1000,
                signaltype === "buy" ? "low" : "high",
                alertOrSignal === "alert"
                  ? signaltype === "buy"
                    ? "#81C784"
                    : "#E57373"
                  : signaltype === "buy"
                  ? "#006400"
                  : "#ff0000",
                ` ${
                  alertOrSignal === "alert"
                    ? "Alert"
                    : alertOrSignal === "signal"
                    ? " Signal"
                    : ""
                } @ ${parseFloat(signalTypedata.close)?.toFixed(2)}`
              );
          }
        });
      }
    }

    function drawResistanceLine(res) {
      tvWidget.value?.onChartReady(() => {
        if (
          priceHistory.value[0]?.close > res.data[0]?.high ||
          priceHistory.value[0]?.close > res.data[1]?.high
        ) {
          for (let i = 2; i < res.data.length; i++) {
            if (priceHistory.value[0]?.close < res.data[i]?.high == true) {
              r3.value =
                r3.value ||
                tvWidget.value
                  .activeChart()
                  .createMultipointShape([{ price: res.data[i]?.high }], {
                    shape: "horizontal_line",
                    lock: true,
                    disableSelection: true,
                    disableSave: true,
                    disableUndo: true,
                    text: `R3@${res.data[i]?.high}`,
                    overrides: {
                      showLabel: true,
                      vertLabelsAlign: "bottom",
                      horzLabelsAlign: "right",
                      linecolor: "red",
                      showPrice: true,
                      textcolor: "red",
                      fontsize: 9,
                      linewidth: 1,
                    },
                  });
              break;
            }
          }
        }
        r1.value =
          r1.value ||
          tvWidget.value
            .activeChart()
            .createMultipointShape([{ price: res.data?.[0]?.high }], {
              shape: "horizontal_line",
              lock: true,
              disableSelection: true,
              disableSave: true,
              disableUndo: true,
              // text: `R1@${res.data?.[0]?.high}`,
              text:
                priceHistory.value[0]?.close < res.data?.[0]?.high
                  ? "R1@" + res.data?.[0]?.high
                  : "R1->S1@" + res.data?.[0]?.high,
              overrides: {
                showLabel: true,
                vertLabelsAlign: "bottom",
                horzLabelsAlign: "right",
                linecolor:
                  priceHistory.value[0]?.close < res.data?.[0]?.high
                    ? "red"
                    : "green",
                showPrice: true,
                textcolor:
                  priceHistory.value[0]?.close < res.data?.[0]?.high
                    ? "red"
                    : "green",
                fontsize: 9,
                linewidth: 1,
              },
            });
        r2.value =
          r2.value ||
          tvWidget.value.activeChart().createMultipointShape(
            [
              {
                price: res.data?.[1]?.high,
              },
            ],
            {
              shape: "horizontal_line",
              lock: true,
              disableSelection: true,
              disableSave: true,
              disableUndo: true,
              // text: "R2@" + res.data?.[1]?.high,
              text:
                priceHistory.value[0]?.close < res.data?.[1]?.high
                  ? "R2@" + res.data?.[1]?.high
                  : "R2->S2@" + res.data?.[1]?.high,
              overrides: {
                showLabel: true,
                vertLabelsAlign: "bottom",
                horzLabelsAlign: "right",
                linecolor:
                  priceHistory.value[0]?.close < res.data?.[1]?.high
                    ? "red"
                    : "green",
                textcolor:
                  priceHistory.value[0]?.close < res.data?.[1]?.high
                    ? "red"
                    : "green",
                fontsize: 9,
                linewidth: 1,
              },
            }
          );
      });
    }

    function drawTrendlineForSupport(res) {
      tvWidget.value?.onChartReady(() => {
        trendLine1.value =
          trendLine1.value ||
          tvWidget.value.activeChart().createMultipointShape(
            [
              {
                time: new Date(res.data?.[0]?.date).getTime() / 1000,
                price: res.data?.[0]?.low,
              },
              {
                time: new Date(res.data?.[1]?.date).getTime() / 1000,
                price: res.data?.[1]?.low,
              },
            ],
            {
              shape: "extended",
              lock: true,
              disableSelection: true,
              disableSave: true,
              disableUndo: true,
              overrides: {
                extendRight: false,
                linecolor: $q.dark.mode ? "#fff" : "#000",
                linewidth: 1,
              },
            }
          );
        trendLine3.value =
          trendLine3.value ||
          tvWidget.value.activeChart().createMultipointShape(
            [
              {
                time: new Date(res.data?.[1]?.date).getTime() / 1000,
                price: res.data?.[1]?.low,
              },
              {
                time: new Date(res.data?.[2]?.date).getTime() / 1000,
                price: res.data?.[2]?.low,
              },
            ],
            {
              shape: "extended",
              lock: true,
              disableSelection: true,
              disableSave: true,
              disableUndo: true,
              overrides: {
                extendRight: false,
                linecolor: $q.dark.mode ? "#fff" : "#000",

                linewidth: 1,
              },
            }
          );
      });
    }

    function drawTrendlineForResistance(res) {
      tvWidget.value?.onChartReady(() => {
        trendLine2.value =
          trendLine2.value ||
          tvWidget.value.activeChart().createMultipointShape(
            [
              {
                time: new Date(res.data?.[0]?.date).getTime() / 1000,
                price: res.data?.[0]?.high,
              },
              {
                time: new Date(res.data?.[1]?.date).getTime() / 1000,
                price: res.data?.[1]?.high,
              },
            ],
            {
              shape: "extended",
              lock: true,
              disableSelection: true,
              disableSave: true,
              disableUndo: true,
              overrides: {
                extendRight: false,
                linecolor: $q.dark.mode ? "#fff" : "#000",

                linewidth: 1,
                fontsize: 9,
              },
            }
          );
        trendLine4.value =
          trendLine4.value ||
          tvWidget.value.activeChart().createMultipointShape(
            [
              {
                time: new Date(res.data?.[1]?.date).getTime() / 1000,
                price: res.data?.[1]?.high,
              },
              {
                time: new Date(res.data?.[2]?.date).getTime() / 1000,
                price: res.data?.[2]?.high,
              },
            ],
            {
              shape: "extended",
              lock: true,
              disableSelection: true,
              disableSave: true,
              disableUndo: true,
              overrides: {
                extendRight: false,
                linecolor: $q.dark.mode ? "#fff" : "#000",

                linewidth: 1,
                fontsize: 9,
              },
            }
          );
      });
    }

    function drawBuySellAndProfitTarget(res) {
      if (
        $store.state.authenticate.isAuthenticated &&
        tvToggles.value.buySell &&
        (tvResolution.value == "1D" || tvResolution.value == "D")
      ) {
        tvWidget.value?.onChartReady(() => {
          buySell.value.length ||
            res.forEach((d) => {
              if (d.profit_target_date) {
                buySell.value = [
                  ...buySell.value,
                  tvWidget.value.activeChart().createShape(
                    {
                      time: new Date(d.profit_target_date).getTime() / 1000,
                      channel: "high",
                    },
                    {
                      shape: "comment",
                      text: "PT - " + parseFloat(d.profit_target)?.toFixed(2),
                      zOrder: "top",
                      overrides: {
                        color: !$q.dark.mode ? "#000000" : "#000000",
                        arrowColor: "#ff0000",
                        fontsize: 8,
                        font: "Arial",
                        backgroundColor: !$q.dark.mode
                          ? "rgba(0, 128, 0, 0.1)"
                          : "rgba(255, 255, 255, 0.5)", // Replace with your desired RGBA color
                        borderColor: "transparent", // Set border color to transparent
                      },
                      lock: true,
                      disableSelection: true,
                      disableSave: true,
                      disableUndo: true,
                    }
                  ),
                  // tvWidget.value
                  //   .activeChart()
                  //   .createMultipointShape([{ price: d.profit_target }], {
                  //     shape: "horizontal_line",
                  //     lock: true,
                  //     disableSelection: true,
                  //     disableSave: true,
                  //     disableUndo: true,
                  //     text: `Profit Target @ ${d.profit_target.toFixed(2)}`,
                  //     overrides: {
                  //       showLabel: true,
                  //       vertLabelsAlign: "bottom",
                  //       horzLabelsAlign: "right",
                  //       linecolor: "green",
                  //       showPrice: true,
                  //       textcolor: "green",
                  //       fontsize: 14,
                  //       linewidth: 2,
                  //     },
                  //   }),
                ];
              }
              if (d.profit_target1_date) {
                buySell.value = [
                  ...buySell.value,
                  tvWidget.value.activeChart().createShape(
                    {
                      time: new Date(d.profit_target1_date).getTime() / 1000,
                      channel: "high",
                    },
                    {
                      shape: "comment",
                      text: "PT1 - " + parseFloat(d.profit_target1)?.toFixed(2),
                      zOrder: "top",
                      overrides: {
                        color: !$q.dark.mode ? "#000000" : "#000000",
                        arrowColor: "#ff0000",
                        fontsize: 8,
                        font: "Arial",
                        backgroundColor: !$q.dark.mode
                          ? "rgba(0, 128, 0, 0.2)"
                          : "rgba(255, 255, 255, 0.5)", // Replace with your desired RGBA color
                        borderColor: "transparent", // Set border color to transparent
                      },
                      lock: true,
                      disableSelection: true,
                      disableSave: true,
                      disableUndo: true,
                    }
                  ),
                  // tvWidget.value
                  //   .activeChart()
                  //   .createMultipointShape([{ price: d.profit_target1 }], {
                  //     shape: "horizontal_line",
                  //     lock: true,
                  //     disableSelection: true,
                  //     disableSave: true,
                  //     disableUndo: true,
                  //     text: `Profit Target 1 @ ${d.profit_target1.toFixed(2)}`,
                  //     overrides: {
                  //       showLabel: true,
                  //       vertLabelsAlign: "bottom",
                  //       horzLabelsAlign: "right",
                  //       linecolor: "green",
                  //       showPrice: true,
                  //       textcolor: "green",
                  //       fontsize: 14,
                  //       linewidth: 2,
                  //     },
                  //   }),
                ];
              }
              if (d.profit_target2_date) {
                buySell.value = [
                  ...buySell.value,
                  tvWidget.value.activeChart().createShape(
                    {
                      time: new Date(d.profit_target2_date).getTime() / 1000,
                      channel: "high",
                    },
                    {
                      shape: "comment",
                      text: "PT2 - " + parseFloat(d.profit_target2)?.toFixed(2),
                      zOrder: "top",
                      overrides: {
                        color: !$q.dark.mode ? "#000" : "#000",
                        arrowColor: "#ff0000",
                        fontsize: 8,
                        font: "Arial",
                        backgroundColor: !$q.dark.mode
                          ? "rgba(0, 128, 0, 0.3)"
                          : "rgba(255, 255, 255, 0.5)", // Replace with your desired RGBA color
                        borderColor: "transparent", // Set border color to transparent
                      },
                      lock: true,
                      disableSelection: true,
                      disableSave: true,
                      disableUndo: true,
                    }
                  ),
                ];
              }
              if (d.stop_loss_date) {
                buySell.value = [
                  ...buySell.value,
                  tvWidget.value.activeChart().createShape(
                    {
                      time: new Date(d.stop_loss_date).getTime() / 1000,
                      channel: "high",
                    },
                    {
                      shape: "comment",
                      text: "SL - " + parseFloat(d.stop_loss)?.toFixed(2),
                      zOrder: "top",
                      overrides: {
                        color: !$q.dark.mode ? "#000" : "#000",
                        arrowColor: "#ff0000",
                        fontsize: 8,
                        font: "Arial",
                        backgroundColor: !$q.dark.mode
                          ? "rgba(255, 0, 0, 0.2)"
                          : "rgba(255, 255, 255, 0.5)", // Replace with your desired RGBA color
                        borderColor: "transparent", // Set border color to transparent
                      },
                      lock: true,
                      disableSelection: true,
                      disableSave: true,
                      disableUndo: true,
                    }
                  ),
                ];
              }
              if (d.sell_date) {
                buySell.value = [
                  ...buySell.value,
                  tvWidget.value.activeChart().createShape(
                    {
                      time: new Date(d.sell_date).getTime() / 1000,
                      channel: "high",
                    },
                    {
                      shape: "arrow_down",
                      text: parseFloat(d.sell_price)?.toFixed(2),
                      zOrder: "top",
                      overrides: {
                        color: "#ff0000",
                        arrowColor: "#ff0000",
                        fontsize: 8,
                        font: "Arial",
                      },
                      lock: true,
                      disableSelection: true,
                      disableSave: true,
                      disableUndo: true,
                    }
                  ),
                ];
              }
              if (d.buy_date) {
                buySell.value.push(
                  tvWidget.value.activeChart().createShape(
                    {
                      time: new Date(d.buy_date).getTime() / 1000,
                      channel: "low",
                    },
                    {
                      shape: "arrow_up",
                      text: `${(0.99 * parseFloat(d.buy_price)).toFixed(
                        2
                      )} to ${parseFloat(d.buy_price)?.toFixed(2)}\n${
                        d.weak_signal != null
                          ? "Weak"
                          : d.strong_signal != null
                          ? "Strong"
                          : d.very_strong_signal != null
                          ? "Very Strong"
                          : d.medium_signal != null
                          ? "Medium"
                          : ""
                      }`,
                      zOrder: "top",

                      overrides: {
                        color: "#006400",
                        fontWeight: "bold", // Add this line to make the text bold
                        arrowColor: "#006400",
                        fontsize: 12,
                        font: "Arial",
                      },
                      lock: true,
                      disableSelection: true,
                      disableSave: true,
                      disableUndo: true,
                    }
                  )
                );
              }
            });
        });
      }
    }

    function drawHighlowShapes(res) {
      if (tvToggles.value.highLow) {
        tvWidget.value?.onChartReady(() => {
          highLow.value.length ||
            res.forEach((d) => {
              if (d.sr_type === "R" && d.high_low_series !== "RH") {
                highLow.value = [
                  ...highLow.value,
                  tvWidget.value.activeChart().createShape(
                    {
                      time: new Date(d.date).getTime() / 1000,
                      channel: "high",
                    },
                    {
                      shape: "text",
                      text: d.high_low_series,
                      bold: true,
                      zOrder: "top",
                      overrides: {
                        color: !$q.dark.mode ? "#26A69A" : "#26A69A",
                        arrowColor: "#ff0000",
                        fontsize: 14,
                        font: "Arial",
                        backgroundColor: !$q.dark.mode
                          ? "rgba(0, 128, 0, 0.1)"
                          : "rgba(255, 255, 255, 0.5)", // Replace with your desired RGBA color
                        borderColor: "transparent", // Set border color to transparent
                      },
                      lock: true,
                      disableSelection: true,
                      disableSave: true,
                      disableUndo: true,
                    }
                  ),
                ];
              }
              if (d.sr_type === "S" && d.high_low_series !== "RL") {
                highLow.value = [
                  ...highLow.value,
                  tvWidget.value.activeChart().createShape(
                    {
                      time: new Date(d.date).getTime() / 1000,
                      channel: "low",
                    },
                    {
                      shape: "text",
                      text: d.high_low_series,
                      bold: true,
                      zOrder: "top",
                      overrides: {
                        color: !$q.dark.mode ? "#F27572" : "#F27572",
                        arrowColor: "#ff0000",
                        fontsize: 14,
                        font: "Arial",
                        backgroundColor: !$q.dark.mode
                          ? "rgba(0, 0 , 255, 0.1)"
                          : "rgba(255, 255, 255, 0.5)", // Replace with your desired RGBA color
                        borderColor: "transparent", // Set border color to transparent
                      },
                      lock: true,
                      disableSelection: true,
                      disableSave: true,
                      disableUndo: true,
                    }
                  ),
                ];
              }
              if (d.high_low_series === "RH" || d.high_low_series === "RL") {
                highLow.value = [
                  ...highLow.value,
                  tvWidget.value.activeChart().createShape(
                    {
                      time: new Date(d.date).getTime() / 1000,
                      channel: d.high_low_series === "RH" ? "high" : "low",
                    },
                    {
                      shape: "arrow_right",
                      text: d.high_low_series,
                      zOrder: "top",
                      overrides: {
                        backgroundColor: "#FFFFFF",
                        color: "#2962FF",
                        fontsize: 10,
                        fontWeight: "bold",
                        font: "Arial",
                      },
                      lock: false,
                      disableSelection: true,
                      disableSave: true,
                      disableUndo: true,
                    }
                  ),
                ];
              }
            });
        });
      }
    }

    function drawCandleStickComment(res) {
      if (
        $store.state.authenticate.isAuthenticated &&
        (tvResolution.value == "1D" || tvResolution.value == "D")
      ) {
        tvWidget.value?.onChartReady(() => {
          candleStick.value.length ||
            res.forEach((d) => {
              candleStick.value = [
                ...candleStick.value,
                tvWidget.value.activeChart().createShape(
                  {
                    time: new Date(d.date).getTime() / 1000,
                    channel: "high",
                  },
                  {
                    shape: "comment",
                    text: d.candlestick_pattern,
                    bold: true,
                    zOrder: "top",
                    overrides: {
                      backgroundColor: "#2962FF",
                      color: "#FFFFFF",
                      fontsize: 8,
                      font: "Arial",
                    },
                    lock: true,
                    disableSelection: true,
                    disableSave: true,
                    disableUndo: true,
                  }
                ),
              ];
            });
        });
      }
    }

    function drawBuySellTarget(res) {
      if ($store.state.authenticate.isAuthenticated && props.isMySignalSignal) {
        tvWidget.value?.onChartReady(() => {
          const data = res[0];
          if (data?.sell_target) {
            sellTarget.value =
              sellTarget.value ||
              createMultipointShapeLine(
                data.sell_target,
                "red",
                `Sell Target @ ${data.sell_target.toFixed(2)}`,
                1
              );
          }
          if (data?.buy_target) {
            buyTarget.value =
              buyTarget.value ||
              createMultipointShapeLine(
                data.buy_target,
                "blue",
                `Buy Target @ ${data.buy_target.toFixed(2)}`,
                1
              );
          }
        });
      }
    }

    function clearShapesGetApiDataAndThenDrawShpaes(
      resolution,
      changedVariable
    ) {
      if (changedVariable == "support") {
        clearShapes(false, changedVariable)
          .then(() => {
            if (tvToggles.value.support) {
              if (
                resolution == "D" ||
                resolution == "1D" ||
                resolution == "2D" ||
                resolution == "3D" ||
                resolution == "4D"
              ) {
                supportDataSearch(tvSymbol.value)
                  .then((res) => {
                    drawSupportLine(
                      res,
                      tvWidget.value,
                      s1.value,
                      s2.value,
                      s3.value,
                      priceHistory.value
                    ).then((r) => {
                      s1.value = r.s1;
                      s2.value = r.s2;
                      s3.value = r.s3;
                    });
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              } else if (
                resolution == "240" ||
                resolution == "180" ||
                resolution == "120" ||
                resolution == "60" ||
                resolution == "45" ||
                resolution == "30" ||
                resolution == "15" ||
                resolution == "5" ||
                resolution == "1"
              ) {
                supportDataSearchHourly(tvSymbol.value)
                  .then((res) => {
                    drawSupportLine(
                      res,
                      tvWidget.value,
                      s1.value,
                      s2.value,
                      s3.value,
                      priceHistory.value
                    ).then((r) => {
                      s1.value = r.s1;
                      s2.value = r.s2;
                      s3.value = r.s3;
                    });
                    setTimeout(() => {
                      if (tvToggles.value.support) {
                        drawSupportLine(
                          res,
                          tvWidget.value,
                          s1.value,
                          s2.value,
                          s3.value,
                          priceHistory.value
                        ).then((r) => {
                          s1.value = r.s1;
                          s2.value = r.s2;
                          s3.value = r.s3;
                        });
                      }
                    }, 4000);
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              } else if (resolution == "1W" || resolution == "W") {
                supportDataSearchWeekly(tvSymbol.value)
                  .then((res) => {
                    drawSupportLine(
                      res,
                      tvWidget.value,
                      s1.value,
                      s2.value,
                      s3.value,
                      priceHistory.value
                    );
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              }
            }
          })
          .catch((err) => {
            // console.log("error in clearing support");
          });
      }
      if (changedVariable == "resistance") {
        clearShapes(true, changedVariable)
          .then(() => {
            if (tvToggles.value.resistance) {
              if (
                resolution == "D" ||
                resolution == "1D" ||
                resolution == "2D" ||
                resolution == "3D" ||
                resolution == "4D"
              ) {
                resistanceDataSearch(tvSymbol.value)
                  .then((res) => {
                    drawResistanceLine(res);
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              }
              if (
                resolution == "240" ||
                resolution == "180" ||
                resolution == "120" ||
                resolution == "60" ||
                resolution == "45" ||
                resolution == "30" ||
                resolution == "15" ||
                resolution == "5" ||
                resolution == "1"
              ) {
                resistanceDataSearchHourly(tvSymbol.value)
                  .then((res) => {
                    drawResistanceLine(res);
                    setTimeout(() => {
                      if (tvToggles.value.resistance) {
                        drawResistanceLine(res);
                      }
                    }, 4000);
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              }
              if (resolution == "1W" || resolution == "W") {
                resistanceDataSearchWeekly(tvSymbol.value)
                  .then((res) => {
                    drawResistanceLine(res);
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              }
            }
          })

          .catch((err) => {});
      }
      if (changedVariable == "trendline") {
        clearShapes(true, changedVariable)
          .then(() => {
            if (tvToggles.value.trendline) {
              if (
                resolution == "D" ||
                resolution == "1D" ||
                resolution == "2D" ||
                resolution == "3D" ||
                resolution == "4D"
              ) {
                supportDataSearch(tvSymbol.value)
                  .then((res) => {
                    drawTrendlineForSupport(res);
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              }
              if (
                resolution == "240" ||
                resolution == "180" ||
                resolution == "120" ||
                resolution == "60" ||
                resolution == "45" ||
                resolution == "30" ||
                resolution == "15" ||
                resolution == "5" ||
                resolution == "1"
              ) {
                supportDataSearchHourly(tvSymbol.value)
                  .then((res) => {
                    drawTrendlineForSupport(res);
                    setTimeout(() => {
                      if (tvToggles.value.trendline) {
                        drawTrendlineForSupport(res);
                      }
                    }, 4000);
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              }
              if (resolution === "1W" || resolution == "W") {
                supportDataSearchWeekly(tvSymbol.value)
                  .then((res) => {
                    drawTrendlineForSupport(res);
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              }
              //end of trendlineSupport
              if (
                resolution == "D" ||
                resolution == "1D" ||
                resolution == "2D" ||
                resolution == "3D" ||
                resolution == "4D"
              ) {
                resistanceDataSearch(tvSymbol.value)
                  .then((res) => {
                    drawTrendlineForResistance(res);
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              }
              if (
                resolution == "240" ||
                resolution == "180" ||
                resolution == "120" ||
                resolution == "60" ||
                resolution == "45" ||
                resolution == "30" ||
                resolution == "15" ||
                resolution == "5" ||
                resolution == "1"
              ) {
                resistanceDataSearchHourly(tvSymbol.value)
                  .then((res) => {
                    drawTrendlineForResistance(res);

                    setTimeout(() => {
                      if (tvToggles.value.trendline) {
                        drawTrendlineForResistance(res);
                      }
                    }, 4000);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
              if (resolution === "1W" || resolution == "W") {
                resistanceDataSearchWeekly(tvSymbol.value)
                  .then((res) => {
                    drawTrendlineForResistance(res);
                  })
                  .catch((error) => {});
              }
              //end of trendlineResistance
            }
          })
          .catch((error) => {});
      }
      if (changedVariable == "buysell") {
        clearShapes(true, changedVariable).then(() => {
          if (
            $store.state.authenticate.isAuthenticated &&
            tvToggles.value.buySell
          ) {
            if (routeName.value === "BackTestEngine") {
              tvWidget.value?.onChartReady(() => {
                let id;
                tvWidget.value
                  .activeChart()
                  .onVisibleRangeChanged()
                  .subscribe(null, ({ from, to }) => {
                    clearShapes(true, changedVariable).then(() => {
                      if (tvToggles.value.buySell == true) {
                        clearTimeout(id);
                        id = setTimeout(() => {
                          drawBuySellAndProfitTarget(
                            props.backTestdata[0][props.symbol]
                          );
                        }, 500);
                      }
                    });
                  });
                clearShapes(true, changedVariable).then(() => {
                  drawBuySellAndProfitTarget(
                    props.backTestdata[0][props.symbol]
                  );
                });
              });
            } else {
              buySellSearch(tvSymbol.value).then((res) => {
                tvWidget.value?.onChartReady(() => {
                  let id;
                  tvWidget.value
                    .activeChart()
                    .onVisibleRangeChanged()
                    .subscribe(null, ({ from, to }) => {
                      clearShapes(true, changedVariable).then(() => {
                        if (tvToggles.value.buySell == true) {
                          clearTimeout(id);
                          id = setTimeout(() => {
                            if (res.data[0]?.symbol == tvSymbol.value) {
                              drawBuySellAndProfitTarget(res.data);
                            }
                          }, 500);
                        }
                      });
                    });
                  clearShapes(true, changedVariable).then(() => {
                    drawBuySellAndProfitTarget(res.data);
                  });
                });
              });
            }
          }
        });
      }
      if (changedVariable == "highlow") {
        clearShapes(true, changedVariable).then(() => {
          if (tvToggles.value.highLow) {
            if (tvResolution.value == "1D" || tvResolution.value == "D") {
              highlowDataSearchSymbolWise(tvSymbol.value).then((res) => {
                tvWidget.value?.onChartReady(() => {
                  let id;
                  tvWidget.value
                    .activeChart()
                    .onVisibleRangeChanged()
                    .subscribe(null, ({ from, to }) => {
                      clearShapes(true, changedVariable).then(() => {
                        if (tvToggles.value.highLow == true) {
                          clearTimeout(id);
                          id = setTimeout(() => {
                            if (
                              tvResolution.value == "1D" ||
                              tvResolution.value == "D"
                            )
                              drawHighlowShapes(res.data.slice(0, 100));
                          }, 500);
                        }
                      });
                    });
                  clearShapes(true, changedVariable).then(() => {
                    drawHighlowShapes(res.data.slice(0, 100));
                  });
                });
              });
            }

            if (tvResolution.value == "60") {
              highlowHourlyDataSearchSymbolWise(tvSymbol.value).then((res) => {
                tvWidget.value?.onChartReady(() => {
                  let id;
                  tvWidget.value
                    .activeChart()
                    .onVisibleRangeChanged()
                    .subscribe(null, ({ from, to }) => {
                      clearShapes(true, changedVariable).then(() => {
                        if (tvToggles.value.highLow == true) {
                          clearTimeout(id);
                          id = setTimeout(() => {
                            // this block is isolated and it runs when frame is move or scroll
                            if (tvResolution.value == "60")
                              drawHighlowShapes(res.data.slice(0, 90));
                          }, 500);
                        }
                      });
                    });
                  clearShapes(true, changedVariable).then(() => {
                    drawHighlowShapes(res.data.slice(0, 90));
                  });
                });
              });
            }

            if (tvResolution.value == "1W") {
              highlowWeeklyDataSearchSymbolWise(tvSymbol.value).then((res) => {
                tvWidget.value?.onChartReady(() => {
                  let id;
                  tvWidget.value
                    .activeChart()
                    .onVisibleRangeChanged()
                    .subscribe(null, ({ from, to }) => {
                      clearShapes(true, changedVariable).then(() => {
                        if (tvToggles.value.highLow == true) {
                          clearTimeout(id);
                          id = setTimeout(() => {
                            // this block is isolated and it runs when frame is move or scroll
                            if (tvResolution.value == "1W")
                              drawHighlowShapes(res.data.slice(0, 30));
                          }, 500);
                        }
                      });
                    });
                  clearShapes(true, changedVariable).then(() => {
                    drawHighlowShapes(res.data.slice(0, 30));
                  });
                });
              });
            }
          }
        });
      }
      if (changedVariable == "adjusted") {
        LocalStorage.set("tvAdjusted", tvToggles.value.adjusted);
        if (!$store.state.authenticate.isAuthenticated) {
          loadTradingViewChart(null);
          return;
        }
        loadTradingViewChart($store.state.accounts.whoAmI.id);
      }

      if (changedVariable == "sl_pt") {
        clearShapes(true, changedVariable).then(() => {
          if (tvToggles.value.sl_pt) {
            tvWidget.value?.onChartReady(() => {
              let id;
              tvWidget.value
                .activeChart()
                .onVisibleRangeChanged()
                .subscribe(null, ({ from, to }) => {
                  clearShapes(true, changedVariable).then(() => {
                    if (tvToggles.value.sl_pt == true) {
                      clearTimeout(id);
                      id = setTimeout(() => {
                        drawSignalsLine();
                      }, 500);
                    }
                  });
                });
              clearShapes(true, changedVariable).then(() => {
                drawSignalsLine();
              });
            });
          }
        });
      }
    }

    function loadShapes(newSymbol = false, resolution) {
      tvWidget.value?.onChartReady(function () {
        tvWidget.value
          .activeChart()
          .onSymbolChanged()
          .subscribe(null, (symbolInfo) => {
            tvSymbol.value = symbolInfo.ticker;
          });
      });
      tvWidget.value?.onChartReady(function () {
        setTimeout(() => {
          clearShapesGetApiDataAndThenDrawShpaes(resolution, "support");
          clearShapesGetApiDataAndThenDrawShpaes(resolution, "resistance");
          clearShapesGetApiDataAndThenDrawShpaes(resolution, "trendline");
          clearShapesGetApiDataAndThenDrawShpaes(resolution, "buysell");
          clearShapesGetApiDataAndThenDrawShpaes(resolution, "highlow");
          clearShapesGetApiDataAndThenDrawShpaes(resolution, "sl_pt");
        }, 1000);
      });

      // DO NOT PUT THIS INSIDE IF CONDITION. Every time this must run as it sets history data in store.
      $store.dispatch("core/getHistoryDataSearch", tvSymbol.value).then(() => {
        priceHistory.value = $store.state.core.historyDataSearch.map((d) => {
          return {
            time: d.date,
            open: d.open,
            high: d.high,
            low: d.low,
            close: d.close,
          };
        });
      });
    }

    const beforeUnmountHandler = () => {
      tvWidget.value.onChartReady(() => {
        $store.commit(
          "chartsymbol/setActiveIndicators",
          tvWidget.value.activeChart().getAllStudies()
        );
      });
    };

    onBeforeUnmount(beforeUnmountHandler);

    onUnmounted(() => {
      if (tvWidget.value !== null) {
        tvWidget.value.remove();
        tvWidget.value = null;
      }
      tvSymbol.value = "NEPSE";
    });

    return {
      setTradingViewHeight,
      routeName,
      tvWidget,
      drawSupportLine,
      clearShapes,
      chartContainer,
      toggleTheme,
      isDarkTheme,
      loadTradingViewChart,
      entityId,
      loadShapes,
      tvToggles,
      isCapacitor,
    };
  },
};
</script>
